import React from 'react';
import { motion } from 'framer-motion';
import { FilePage } from './FilePage';
import type { StoryBeat } from '../types/offer';
interface StoryFileProps {
  beat: StoryBeat;
  redacted: boolean;
}
const punchTone: Record<StoryBeat['tone'], string> = {
  neutral: 'text-bone',
  danger: 'text-[#ff6fb8]',
  gold: 'text-gold'
};
export function StoryFile({
  beat,
  redacted
}: StoryFileProps) {
  return <FilePage id={beat.id} number={beat.number} label={beat.tag} tone={beat.tone === 'danger' ? 'danger' : 'gold'} data-id="element-270" data-mp="36aj01riqqan3">
      <div className="grid gap-6 sm:gap-8 lg:grid-cols-[1.1fr_0.9fr] lg:gap-14" data-id="element-271" data-mp="3adyy8sagkj1w">
        <div className="relative" data-id="element-272" data-mp="2we674vv0s0te">
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.6
        }} className="max-w-[38rem] text-[15px] leading-[1.85] text-ash" data-id="element-273" data-mp="2wf7n9eqw7dhz">
            {beat.lead}
          </motion.p>

          {redacted ? <div aria-hidden="true" className="pointer-events-none absolute inset-0 hidden flex-col justify-start gap-[0.62rem] pt-[0.35rem] sm:flex" data-id="element-274" data-mp="16h1e218qa2bm">
              {[0, 1, 2, 3].map(line => <motion.span key={line} initial={{
            scaleX: 1
          }} whileInView={{
            scaleX: 0
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.55,
            delay: 0.15 + line * 0.13,
            ease: [0.65, 0, 0.35, 1]
          }} style={{
            width: `${[96, 88, 92, 62][line]}%`
          }} className="h-[1.1rem] origin-left rounded-[2px] bg-[#101014] shadow-[0_0_0_1px_rgba(255,255,255,0.06)]" data-id="element-275" data-mp="1fchamq0vavkw" />)}
            </div> : null}

          <p className="mt-4 font-mono text-[9px] uppercase tracking-[0.16em] text-white/25 sm:mt-6 sm:text-[9.5px]" data-id="element-276" data-mp="230qu3lalz78v">
            {redacted ? 'Fragmento desclasificado · Nivel 5' : 'Transcripción íntegra · Nivel 5'}
          </p>
        </div>

        <motion.blockquote initial={{
        opacity: 0,
        y: 26,
        filter: 'blur(6px)'
      }} whileInView={{
        opacity: 1,
        y: 0,
        filter: 'blur(0px)'
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.8,
        delay: 0.25,
        ease: [0.22, 1, 0.36, 1]
      }} className={`relative self-center rounded-xl border border-white/[0.08] bg-panel p-5 font-display text-[1.2rem] italic leading-[1.4] sm:p-7 sm:text-[1.7rem] ${punchTone[beat.tone]}`} data-id="element-277" data-mp="19n7xphb2lm3b">
          <span aria-hidden="true" className="absolute -top-2.5 left-6 rounded border border-white/15 bg-ink px-2 py-0.5 font-mono text-[8.5px] not-italic uppercase tracking-[0.16em] text-white/40" data-id="element-278" data-mp="vn6nhb8x12b6">
            Nota al margen
          </span>
          “{beat.punch}”
        </motion.blockquote>
      </div>
    </FilePage>;
}